import WFS from '@/components/mapa/capas/geoserver/WFS.js';
import WMS from '@/components/mapa/capas/geoserver/WMS.js';

export default class Capa {
  _wfs;
  _wms;
  _click;
  _z_index;
  _geojson;

  visible;

  constructor({
    capa,
    titulo = 'titulo de la capa',
    z_index = 0,
  }) {
    this.titulo = titulo;
    this._geoserverCapa = capa;
    this._z_index = z_index;
    this._wfs = new WFS(capa);
    this._wms = new WMS(capa);
    this._click = ([f, t]) => {
      // console.log(f, t);
    };

    this.visible = true;
  }
  nombre = '';


  get id() {
    return this.geoserverCapa.split(":")[1];
  }

  get geoserverCapa() {
    return this._geoserverCapa;
  }

  /**
   * @param {Number} index
   */
  set z_index(index) {
    this._z_index = index;
  }
  get z_index() {
    return this._z_index;
  }

  get wfs() {
    return this._wfs;
  }

  get wms() {
    return this._wms;
  }

  /**
   * @param {Function} event
   */
  set click(event) {
    this._click = event;
  }
  get click() {
    return this._click;
  }

  set geojson(geojson) {
    this._geojson = geojson;
  }
  get geojson() {
    return this._geojson;
  }

  /**
   * @param {String} cql
   */
  set geoserverFiltro(cql) {
    this._wfs.filtro = cql;
    this._wms.filtro = cql;
  }
}
